<template>
  <div class="module_course page_content course_curation" aria-label="Course Curate Page Content">

    <course-header class="header_course_learn" :course-id="course.uuid" :is-curate="true" :title="courseTitle" :plan="items" @saved="afterSave"></course-header>

    <div class="row page_content_container">

    <div class="curate-content-section row">
      <div class="col-12">

        <div class="row curate-header">
          <div class="first-column ace_sec_txt" role="heading" aria-level="1">
            {{ $tf('selectACompetencyTree') }}
          </div>

          <div class="second-column">
            <button class="add-to-topic" @click="addToTopic">
              <span class="icon-link2"></span>
              <span class="link-source-text">Link Resources to Competencies</span>
            </button>

            <div class="second-column-content">
              <div class="link-resource ace_sec_txt">Link Resources to the Competency Tree</div>
                <div class="search-box-container">
                  <a href="javascript://" class="icon-filter" v-b-modal.filtering></a>
                  <input type="text" class="input-search" placeholder="type in search term and/or click search" v-on:keyup.enter="searchWithTerms" v-model.trim="terms" aria-label="type in search term and/or click search">
                  <button class="btn btn_srh" @click="searchWithTerms" aria-label="go">
                    <span class="ic_srh ic_search" aria-hidden="true"></span>
                  </button>
                </div>
              </div>

            </div>
          </div>

            <div class="row">

              <div :key="uuid" class="col-6 toc_panel">
                  <b-list-group>
                      <div class="list-group-item">
                          <div class="toc_row table-content-header">
                              <span class="icon-ic_ToC"></span>
                              <span class="header-text toc_hd_txt">{{course.title}}</span>
                              <div class="action_menu_container pg_hd_sec_menu sty_3">
                                <div class="">

                                  <b-dropdown no-caret class="navigation-menu" aria-label="$t('aria.subMenu.competencyMenu')">
                                    <template slot="button-content">
                                      <span class="btn ic_btn">
                                        <span class="ic9-iconMore-0005 ic_more"></span>
                                      </span>
                                    </template>

                                    <div class="links new_menu" aria-labelledby="mainMenuDropdownButton">
                                      <b-dropdown-item  @click="openNewCompetencyBox('Begin')" variant="primary" aria-label="Insert Competency Above">
                                        <span class="lnk_txt">
                                          {{ $tf('insertCompetencyAbove') }}
                                        </span>
                                      </b-dropdown-item>
                                      <b-dropdown-item@click="openNewCompetencyBox('End')" variant="primary" aria-label="Insert Competency Below">
                                        <span class="lnk_txt">
                                        {{ $tf('insertCompetencyBelow') }}
                                        </span>
                                      </b-dropdown-item>
                                    </div>
                                  </b-dropdown>

                                </div>
                              </div>
                          </div>
                      </div>
						<div class="content-scroll-column">
						  <b-list-group-item class="topic-list-item" v-for="topic in items" :key="topic.uuid">

							  <template  v-if="topic.action !== 'DELETE'">
    							  <div class="toc_row row_1 row_collapsed" :id="'rw_' + topic.uuid">
                      <span class="toc_slot toc_slot_select">
                        <input class="radio_btn" type="radio" :id="'r_' + topic.uuid" :value="'v_' + topic.uuid" @click="addCompetency(topic.uuid, topic.children)" v-model="selectMCFromList" :aria-labelledby="'courseCompetencyLabel' + topic.uuid">
                      </span>
                      <span class="toc_slot toc_slot_expand">
    								  <button class="icon ic-ec-1" v-b-toggle="'tc_' + topic.uuid" v-on:click="addExpandClass(topic.uuid)"></button>
                      </span>
    								  <label :for="'r_' + topic.uuid" @click="addCompetency(topic.uuid, topic.children)" :id="'courseCompetencyLabel' + topic.uuid" class="lnk_txt">{{topic.title}}</label>
    								  <span class="ic_container_actions">
    								    <button
                          class="icon-bin"
                          @click="showDeleteItemConfirmBox('competency', topic)"
                          :aria-label="$tf('delete')"
                          :title="$tf('delete')"
                          v-b-tooltip.hover>
                        </button>
    								    <button
                          class="icon-pencil"
                          @click="openItemEditBox('competency', topic)"
                          :aria-label="$tf('edit')"
                          :title="$tf('edit')"
                          v-b-tooltip.hover>
                        </button>
    								  </span>
    							  </div>

    							  <!--sub topic -->
    							  <b-collapse :id="'tc_' + topic.uuid">
                                    <b-list-group v-if="topic.children">
                                        <draggable v-model="topic.children" :options="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                                            <transition-group tag="div" class="toc_drag_list" type="transition" :name="'content-list'">
                                                <b-list-group-item class="topic-list-item" v-for="subtopic in topic.children" :key="subtopic.uuid">
                                                    <template  v-if="subtopic.action !== 'DELETE'">
            											<template v-if="subtopic.type === 'LearningTopic'">
            												<div class="toc_row row_2 row_collapsed" :id="'rw_' + subtopic.uuid" :class="ensureLockInfo(subtopic)">
                                      <span class="toc_slot toc_slot_select" aria-hidden="true"></span>
                                      <span class="toc_slot toc_slot_expand">
            												  <button class="icon ic-ec-1" v-b-toggle="'tc_' + subtopic.uuid" v-on:click="addExpandClass(subtopic.uuid)"></button>
                                      </span>
            												  <label :for="'r_' + subtopic.uuid" @click="addCompetency(subtopic.uuid, subtopic.children)" :id="'courseMicroCompetencyLabel_'  + subtopic.uuid" class="lnk_txt">{{subtopic.title}}</label>

                                      <span class="ic_container_actions">
                                        <span
                                          v-if="subtopic.isLocked"
                                          class="ic-lock"
                                          :title="$tf('openOn') + ' ' + subtopic.unlockText"
                                          v-b-tooltip.hover
                                        ></span>
            												    <button class="icon-bin" @click="showDeleteItemConfirmBox('microCompetency', subtopic)" aria-label="delete"></button>
            												    <button class="icon-pencil" @click="openItemEditBox('microCompetency', subtopic)" aria-label="edit"></button>
            												  </span>
            												</div>
            											</template>
            											<template v-else>
                  										    <div class="toc_row row_3 top-level-assets">
                                                                <a style="cursor: move;">
                                              <span class="toc_slot toc_slot_select" aria-hidden="true"></span>
                                              <span class="toc_slot toc_slot_expand" aria-hidden="true"></span>
                                              <span class="toc_asset_body">
                                              <span class="ic_container">
                  													<span v-if="subtopic.fileType === 'assessment'" class="icon icon-assessment"></span>
                  													<span v-if="subtopic.fileType === 'video'" class="icon icon-video"></span>
                  													<span v-if="subtopic.fileType === 'pdf'" class="icon icon-file-pdf"></span>
                  													<span v-if="subtopic.fileType === 'csv'" class="icon icon-csvFile"></span>
                  													<span v-if="subtopic.fileType === 'txt'" class="icon icon-file-text"></span>
                  													<span v-if="subtopic.fileType === 'mp4' || subtopic.fileType === 'mp3'" class="icon icon-video"></span>
                                            <span v-if="subtopic.fileType === 'zip'" class="icon icon-file-zip"></span>
                                            <span v-if="subtopic.fileType === 'scorm'" class="icon icon-scorm"></span>
                  													<span v-if="subtopic.fileType === 'doc' || subtopic.fileType === 'docx'" class="icon icon-file-word"></span>
                  													<span v-if="subtopic.fileType === 'xlsx' || subtopic.fileType === 'xls'" class="icon icon-file-excel"></span>
                  													<span v-if="subtopic.fileType === 'pptx' || subtopic.fileType === 'ppt'" class="icon icon-pagePPT"></span>
                  													<span v-if="subtopic.fileType === 'html'" class="icon icon-pageURL"></span>
                  													<span v-if="subtopic.fileType === 'externalurl'" class="icon icon-pageURL"></span>
                  													<span v-if="subtopic.fileType === 'jpg' || subtopic.fileType === 'jpeg' || subtopic.fileType === 'png' || subtopic.fileType === 'gif'" class="icon icon-image"></span>
                  													<span v-if="subtopic.fileType === 'other'"  class="icon icon-asset"></span>
                                            <span v-if="subtopic.fileType === 'scorm'" class="icon icon-scorm"></span>
                                              </span>
                  													<span class="lnk_txt">{{subtopic.title}}</span>
                                              </span>
                                            <span class="ic_container_actions">
                                              <button class="icon-bin" @click="showDeleteItemConfirmBox('content', subtopic)" aria-label="delete"></button>
                                              <button class="icon-pencil" @click="openItemEditBox('content', subtopic)" aria-label="edit"></button>
                                            </span>
                                          </a>
                  											</div>
            											</template>
        											</template>
        											<!--<span class="lnk_txt" @click="addCompetency(subtopic.uuid, subtopic.children)">{{subtopic.title}}</span>-->

        										  <!-- sub sub topic -->
        										  <b-collapse :id="'tc_' + subtopic.uuid">
        											  <b-list-group v-if="subtopic.children">
        												  <draggable v-model="subtopic.children" :options="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
        													  <transition-group tag="div" class="toc_drag_list" type="transition" :name="'content-list'">
        														  <b-list-group-item class="topic-list-item" v-for="subsubtopic in subtopic.children" :key="subsubtopic.uuid">
        															  <template v-if="subsubtopic.action !== 'DELETE'">
        																  <div class="toc_row row_3" :id="'tc_' + subsubtopic.uuid">
        																	  <a style="cursor: move;">
                                              <span class="toc_slot toc_slot_select" aria-hidden="true"></span>
                                              <span class="toc_slot toc_slot_expand" aria-hidden="true"></span>
                                              <span class="toc_asset_body">
                                              <span class="ic_container">
        																		  <span v-if="subsubtopic.fileType === 'assessment'" class="icon icon-assessment"></span>
        																		  <span v-if="subsubtopic.fileType === 'video'" class="icon icon-video"></span>
        																		  <span v-if="subsubtopic.fileType === 'pdf'" class="icon icon-file-pdf"></span>
        																		  <span v-if="subsubtopic.fileType === 'csv'" class="icon icon-csvFile"></span>
        																		  <span v-if="subsubtopic.fileType === 'txt'" class="icon icon-file-text"></span>
        																		  <span v-if="subsubtopic.fileType === 'mp4' || subsubtopic.fileType === 'mp3'" class="icon icon-video"></span>
        																		  <span v-if="subsubtopic.fileType === 'zip'" class="icon icon-file-zip"></span>
        																		  <span v-if="subsubtopic.fileType === 'doc' || subsubtopic.fileType === 'docx'" class="icon icon-file-word"></span>
        																		  <span v-if="subsubtopic.fileType === 'xlsx' || subsubtopic.fileType === 'xls'" class="icon icon-file-excel"></span>
        																		  <span v-if="subsubtopic.fileType === 'pptx' || subsubtopic.fileType === 'ppt'" class="icon icon-pagePPT"></span>
        																		  <span v-if="subsubtopic.fileType === 'html'" class="icon icon-pageURL"></span>
        																		  <span v-if="subsubtopic.fileType === 'externalurl'" class="icon icon-pageURL"></span>
        																		  <span v-if="subsubtopic.fileType === 'jpg' || subsubtopic.fileType === 'jpeg' || subsubtopic.fileType === 'png' || subsubtopic.fileType === 'gif'" class="icon icon-image"></span>
        																		  <span v-if="subsubtopic.fileType === 'other'"  class="icon icon-asset"></span>
                                              <span v-if="subsubtopic.fileType === 'scorm'" class="icon icon-scorm"></span>
                                              </span>
        																		  <span class="lnk_txt">{{subsubtopic.title}}</span>
                                              </span>
                                              <span class="ic_container_actions">
                                                <button class="icon-pencil" @click="openItemEditBox('content', subsubtopic)" aria-label="edit"></button>
                                              </span>
        																	  </a>
        																  </div>
        															  </template>
        														  </b-list-group-item>
        													  </transition-group>
        												  </draggable>
        											  </b-list-group>
        										  </b-collapse>
        										  <!-- sub sub topic ends-->
        									    </b-list-group-item>
                                            </transition-group>
                                        </draggable>
    								</b-list-group>
    							  </b-collapse>
    							  <!--sub topic ends -->
							  </template>
						  </b-list-group-item>
					  </div>
                  </b-list-group>

                <div>
                  <b-modal class="modal__v22_2" ref="addCompetencyModal" title="Insert Competency" :header-bg-variant="'course-content-edit-modal'" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                    <div slot="modal-header" class="row header-section w-100">
                      <div class="col-8 hd">
                    		<div class="ic_container">

          							</div>
                        <div class="hd_txt">
                          <span>Insert Competency</span>
                        </div>
            					</div>
                      <div class="col-4 btn_container pr-0">
                        <button class="btn_close" aria-label="close" @click="closeNewCompetencyBox('competency')">
                           <span class="ic-close"></span>
                        </button>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-11 popup_content">

                        <div class="row fld_row mb-4">
                          <div class="col-12 fld_label">
                            Competency Name <sup>*</sup>
                          </div>
                          <div class="col-12 fld_input">
                            <b-form-input class="inputTitle"
                              v-model.trim="newCompetencyTitle"
                              type="text"
                              :state="newCompetencyTitleState"
                              :aria-label="newCompetencyTitle"
                              aria-describedby="inputTitleFeedback">
                            </b-form-input>
                            <b-form-invalid-feedback>
                              Title must not be empty.
                            </b-form-invalid-feedback>
                          </div>
                        </div>

                        <div class="row fld_row">
                          <div class="col-12 fld_label">
                            Competency Description
                          </div>
                          <div class="col-12 fld_input">
                            <textarea rows="4" cols="75"
                              v-model="newCompetencyDescription"
                              aria-labelledby="editCompetencyDesc">
                            </textarea>
                          </div>
                        </div>

                      </div>
                    </div>

                    <div slot="modal-footer" class="w-100">
                      <b-button @click="createNewCompetency('competency')" class="btn button-primary float-right mr-2"> ok </b-button>
                      <b-button @click="closeNewCompetencyBox('competency')" class="btn button-primary float-right mr-2"> cancel </b-button>
                    </div>
                  </b-modal>
                </div>

                <div>
                  <b-modal class="modal__v22_2" ref="competencyEditModal" :title="'Edit Competency Details'" :header-bg-variant="'course-content-edit-modal'" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>

                    <div slot="modal-header" class="row header-section w-100">
                        <div class="col-8 hd">
                      		<div class="ic_container">

            							</div>
                          <div class="hd_txt">
                            <span>Edit Competency Details</span>
                          </div>
              					</div>
                        <div class="col-4 btn_container pr-0">
                          <button class="btn_close" title="close the popup" aria-label="close" @click="closeItemEditBox('competency')">
                             <span class="ic-close"></span>
                          </button>
                        </div>
                    </div>

                    <div class="row modal_flds_container">
    									<div class="col-12 sec_content">

    										<div class="row fld_row">
    											<div class="col-12 fld_label">
    												 Competency Name <sup>*</sup>
    											 </div>
    											 <div class="col-12 fld_input">
                             <b-form-input class="inputTitle"
                               v-model.trim="itemTitle"
                               type="text"
                               :state="itemTitleState"
                               :aria-label="itemTitle"
                               aria-describedby="inputTitleFeedback">
                             </b-form-input>
                             <b-form-invalid-feedback>
                               Title must not be empty.
                             </b-form-invalid-feedback>
    										  </div>
    										</div>

                        <div class="row fld_row">
    											<div class="col-12 fld_label">
    												 <span for="description" id="editCompetencyDesc">Competency Description</span>
    											 </div>
    											 <div class="col-12 fld_input">
                             <textarea rows="4" cols="75"
                                 v-model="itemDescription"
                                 aria-labelledby="editCompetencyDesc">
                             </textarea>
    										  </div>
    										</div>

                      </div>
                    </div>

                    <div slot="modal-footer" class="w-100">
                      <b-button @click="updateAndCloseItemEditBox('competency')" class="btn button-primary float-right mr-2"> ok </b-button>
                      <b-button @click="closeItemEditBox('competency')" class="btn button-primary float-right mr-2"> cancel </b-button>
                    </div>
                  </b-modal>
                </div>

                  <div>
                      <b-modal class="modal__v22_2" ref="microCompetencyEditModal" :header-bg-variant="'course-content-edit-modal'" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>

                        <div slot="modal-header" class="row header-section w-100">
                          <!--
              						<div class="col-1 ic_container">
              							<span class="ic ic22-buy"></span>
              						</div>
                          -->
              	          <div class="col-8 hd_txt" style="margin-left: auto; padding-top: 1px;">
                            <span>Edit Micro Competency Details</span>
              	          </div>
                          <div class="col-4 btn_container" style="padding-right: 0px;">
                            <button class="btn_close" aria-label="close" title="close the popup" @click="closeItemEditBox('microCompetency')">
                              <span class="ic-close"></span>
                            </button>
                          </div>
                        </div>

                        <div class="modal_flds_container">
                          <div class="col-11 sec_content" style="margin: auto;">

                            <div class="row fld_row">
                              <div class="col-12 fld_label">
                                Competency Name <sup>*</sup>
                              </div>
                              <div class="col-12">
                                <b-form-input class="inputTitle"
                                  v-model.trim="itemTitle"
                                  type="text"
                                  :state="itemTitleState"
                                  :aria-label="itemTitle"
                                  aria-describedby="inputTitleFeedback">
                                </b-form-input>
                                <b-form-invalid-feedback>
                                    Title must not be empty.
                                </b-form-invalid-feedback>
                              </div>
                            </div>

                            <div class="row fld_row">
                              <div class="col-12 fld_label">
                                <span for="description" id="microCompetencyDesc">Micro Competency Description</span>
                              </div>
                              <div class="col-12">
                                <textarea rows="4" cols="55"
                                  v-model="itemDescription"
                                  aria-labelledby="microCompetencyDesc" class="w-100">
                                </textarea>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div slot="modal-footer" class="w-100">
                          <b-button @click="updateAndCloseItemEditBox('microCompetency')" class="btn button-primary float-right mr-2"> ok </b-button>
                          <b-button @click="closeItemEditBox('microCompetency')" class="btn button-primary float-right mr-2"> cancel </b-button>
                        </div>

                      </b-modal>
                  </div>
                  <div>
                      <b-modal class="modal__v22_2" ref="microCompetencyReleaseModal" :header-bg-variant="'course-content-edit-modal'" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                        <div slot="modal-header" class="row header-section w-100">
                          <div class="col-8 hd_txt" style="margin-left: auto; padding-top: 1px;">
                            <span>Edit Unlock Logic for Micro Competency</span>
                          </div>
                          <div class="col-4 btn_container" style="padding-right: 0px;">
                            <button class="btn_close" aria-label="close" title="close the popup" @click="closeMCReleaseBox()">
                              <span class="ic-close"></span>
                            </button>
                          </div>
                        </div>

                        <div class="modal_flds_container">
                          <div class="col-11 sec_content" style="margin: auto;">

                            <div class="row fld_row">
                              <div class="col-12 fld_label">
                                {{itemToEdit.title}}
                              </div>
                              <div class="col-12">
                              </div>
                            </div>

                            <div class="row fld_row">
                              <div class="col-12 fld_label">
                                <input class="mr-2" type="radio" name="selectionType" id="all" value=0 v-model="selectionType" @change="resetList" >
                                No Unlock logic set.
                              </div>
                            </div>

                            <div class="row fld_row">
                              <div class="col-12 fld_label">
                                <input class="mr-2" type="radio" name="selectionType" id="all" value=1 v-model="selectionType" @change="resetList">
                                Lock until manually unlocked by Instructor.
                              </div>
                            </div>

                            <div class="row fld_row">
                              <div class="col-6 fld_label">
                                <input class="mr-2" type="radio" name="selectionType" id="all" value=2 v-model="selectionType" @change="resetList">
                                Unlocked on
                              </div>
                              <div class="col-6 fld_input">
                                <datepicker id="unlockDate" v-model="unlockDate" name="uniquename" aria-describedby="unlockDateFeedback"  :disabledDates="disabledDates"></datepicker>
                                <b-form-invalid-feedback id="unlockDateFeedback">
                                  Unlock Date can not be empty, Please select!
                                </b-form-invalid-feedback>
                              </div>
                            </div>

                            <div class="row fld_row">
                              <div class="col-6 fld_label">
                                <input class="mr-2" type="radio" name="selectionType" id="all" value=4 v-model="selectionType" @change="resetList">
                                Select Competency after which the Micro Competency will be unlocked.
                              </div>
                              <div class="col-6 fld_label">
                                <autocomplete
                                  ref="`autocomplete_c`"
                                  :source="allCs"
                                  :placeholder="getDynamicSelectPlaceholder('competency')"
                                  aria-label="start typing and/or click"
                                  input-class="form-control"
                                  :results-display="getDynamicSelectFormattedDisplay"
                                  @selected="dynamicSelectAfterSelected($event)">
                                </autocomplete>
                              </div>
                            </div>

                            <div class="row fld_row">
                              <div class="col-12">
                                <input class="mr-2" type="radio" name="selectionType" id="all" value=5 v-model="selectionType" @change="resetList">
                                Select Micro Competency after which the Micro Competency will be unlocked.
                                  <autocomplete
                                    ref="`autocomplete_mc`"
                                    :source="allMCs"
                                    :placeholder="getDynamicSelectPlaceholder('mc')"
                                    aria-label="start typing and/or click"
                                    input-class="form-control"
                                    :results-display="getDynamicSelectFormattedDisplay"
                                    @selected="dynamicSelectAfterSelected($event)">
                                  </autocomplete>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div slot="modal-footer" class="w-100">
                                  <b-button @click="updateReleaseLogic()" class="btn button-primary float-right mr-2"> ok </b-button>
                                  <b-button @click="closeMCReleaseBox()" class="btn button-primary float-right mr-2"> cancel </b-button>
                        </div>

                      </b-modal>
                  </div>

                  <div>
                      <b-modal class="modal__v22_2" ref="microCompetencyEditStartModal" :title="itemTitle" :header-bg-variant="'course-content-edit-modal'" size="lg" hide-header-close no-close-on-backdrop no-close-on-esc centered hide-footer>

                      <div slot="modal-header" class="w-100">
              					<div class="row">
              						<!--div class="col-1 ic_container">
              							<pan class="ic ic22-buy"></span>
              						</div-->
              	          <div class="col-8 hd_txt">
                            {{itemTitle}}
              	          </div>
              	          <div class="col-3 btn_container" style="padding-right: 25px;">
                            <button class="btn_close" aria-label="close" title="close the popup" @click="closeMCStartEditBox()">
                              <span class="ic-close"></span>
                            </button>
              						</div>
              					</div>
              				</div>

                      <div class="row">
                        <div class="col-10" style="margin: 0 auto;">

                        <div class="row fld_row mt-3 mb-4">
                          <div class="col-9 fld_label">
                            Edit Title and Description of this Micro Competency
                          </div>
                          <div class="col-3">
                            <b-button @click="openMCEditBox()" class="btn button-primary"> Go </b-button>
                          </div>
                        </div>

                        <div class="row fld_row mb-4" v-if="this.itemToEdit.originUuid && !this.itemToEdit.sharedCopy">
                          <div class="col-9 fld_label">
                            Edit the Master of this Micro Competency
                          </div>
                          <div class="col-3">
                            <b-button @click="editMaster()" class="btn button-primary"> Go </b-button>
                          </div>
                        </div>

                        <div class="row fld_row mb-4" v-if="this.itemToEdit.originUuid && this.itemToEdit.sharedCopy">
                          <div class="col-9 fld_label">
                            Edit contents of the Micro Competency in this course. <br/>
                            <small>
                              Note: Edits will be made on a copied version.
                              <a href="javascript:void(0)" @click="showNote = !showNote">
                                {{ showNote ? 'Show less' : 'Know more' }}
                              </a>
                            </small>

                            <transition name="fade-slide">
                              <p v-if="showNote" class="note-expanded text-muted small pt-2">
                                The original Micro Competency will not be changed.
                                A copy will be made for editing.
                                The modified copy of the Micro-Competency will be used in this course
                                and also available to use in other courses.
                              </p>
                            </transition>
                          </div>
                          <div class="col-3">
                            <b-button @click="copyMaster(itemToEdit)" class="btn button-primary">  {{savingButtonMessage}}</b-button>
                          </div>
                        </div>

                        <div class="row fld_row">
                          <div class="col-9 fld_label">
                            Edit the Unlock Logic of this Micro Competency
                          </div>
                          <div class="col-3">
                            <b-button @click="openMCReleaseBox()" class="btn button-primary"> Go </b-button>
                          </div>
                        </div>

                        </div>
                      </div>

                    </b-modal>
                  </div>

                  <div>
                      <b-modal class="modal__v22_2" ref="assessmentEditModal" :title="'Edit Assessment Details'" :header-bg-variant="'course-content-edit-modal'" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                          <div class="page_section_row">
                              <span class="float-left"></span>
                              <b-form-input class="inputTitle"
                                    v-model.trim="itemTitle"
                                    type="text"
                                    :state="itemTitleState"
                                    :aria-label="itemTitle"
                                    aria-describedby="inputTitleFeedback">
                              </b-form-input>
                              <b-form-invalid-feedback>
                                  This field must not be empty.
                              </b-form-invalid-feedback>
                          </div>
                          <div class="page_section_row description-row">
                              <div class="heading border-0">
                                  <span for="description" id="editAssessmentDesc">Assessment Description</span>
                              </div>
                              <div class="value ml-3">
                                  <textarea rows="4" cols="75"
                                      v-model="itemDescription"
                                      aria-labelledby="editAssessmentDesc">
                                  </textarea>
                              </div>
                          </div>
                          <div class="page_section_row description-row" style="display: none;">
                                <div class="max-attempts col-6" :class="{invalid: $v.assessmentMaxAttempt.$error}" >
                                    <div class="heading border-0">
                                        <span for="maxAttempt" id="maximumAttempt">Maximum # of Attempts</span>
                                    </div>
                                    <div class="value ml-3">
                                        <input
                                            type="number"
                                            id="maxAttempt"
                                            @blur="$v.assessmentMaxAttempt.$touch()"
                                            aria-labelledby="maximumAttempt"
                                            v-model.number="assessmentMaxAttempt">
                                    </div>
                                </div>
                          </div>
                          <div slot="modal-header" class="header-section">
                            <div class="popup-heading">Edit Assessment Details</div>
                            <button class="btn_close" aria-label="close" @click="closeItemEditBox('assessment')">
                               <span class="ic-close"></span>
                            </button>
                          </div>
                          <div slot="modal-footer" class="w-100">
                              <b-button @click="updateAndCloseItemEditBox('assessment')" class="btn button-primary float-right mr-2"> ok </b-button>
                              <b-button @click="closeItemEditBox('assessment')" class="btn button-primary float-right mr-2"> cancel </b-button>
                          </div>
                      </b-modal>
                  </div>

                  <div>
                      <b-modal class="modal__v22_2" ref="resourceEditModal" :header-bg-variant="'course-content-edit-modal'" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                        <div slot="modal-header" class="row header-section w-100">
                          <div class="col-8 hd">
                            <div class="ic_container">

                            </div>
                            <div class="hd_txt">
                              <span>Edit Resource Details</span>
                            </div>
                          </div>
                          <div class="col-4 btn_container pr-0">
                            <button class="btn_close" aria-label="close" @click="closeItemEditBox('resource')">
                              <span class="ic-close"></span>
                            </button>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-11 popup_content">

                            <div class="row fld_row mb-4">
                              <div class="col-12 fld_label">
                                Resource Name <sup>*</sup>
                              </div>
                              <div class="col-12 fld_input">
                                <b-form-input class="inputTitle"
                                  v-model.trim="itemTitle"
                                  type="text"
                                  :state="itemTitleState"
                                  :aria-label="itemTitle"
                                  aria-describedby="inputTitleFeedback">
                                </b-form-input>
                                <b-form-invalid-feedback>
                                  Title must not be empty.
                                </b-form-invalid-feedback>
                              </div>
                            </div>

                            <div class="row fld_row mb-4">
                              <div class="col-12 fld_label">
                                <span for="description" id="editResourceDesc">Resource Description</span>
                              </div>
                              <div class="col-12 fld_input">
                                <textarea rows="4" cols="75"
                                    v-model="itemDescription"
                                    aria-labelledby="editResourceDesc">
                                </textarea>
                              </div>
                            </div>

                            <template v-if="this.contentType === 'REMOTE'">
                              <div class="row fld_row mb-4">
                                <div class="col-12 fld_label">
                                  <span for="description">Resource URL</span>
                                </div>
                                <div class="col-12 fld_input" :class="{invalid: $v.contentUri.$error}">
                                  <input
                                    type="text"
                                    id="uri"
                                    style="width: 96%;"
                                    @blur="$v.contentUri.$touch()"
                                    v-model.trim="contentUri">
                                  </div>
                                </div>
                            </template>

                          </div>
                        </div>

                          <div slot="modal-footer" class="w-100">
                              <b-button @click="updateAndCloseItemEditBox('resource')" class="btn button-primary float-right mr-2"> ok </b-button>
                              <b-button @click="closeItemEditBox('resource')" class="btn button-primary float-right mr-2"> cancel </b-button>
                          </div>
                      </b-modal>
                  </div>

                <div>
                  <b-modal class="modal__v22_2" ref="deleteItemModal" :title="'Delete'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                    <div slot="modal-header" class="row header-section w-100">
                      <div class="col-8 hd">
                    		<div class="ic_container">

          							</div>
                        <div class="hd_txt">
                          <span>Confirm Delete</span>
                        </div>
            					</div>
                      <div class="col-4 btn_container pr-0">
                        <button class="btn_close" aria-label="close" @click="closeDeleteConfirmBox">
                           <span class="ic-close"></span>
                        </button>
                      </div>
                    </div>

                    <div class="row modal_msg_container">
											<div class="col-12 msg_sec">
												 <span>{{itemDeleteMessage}}</span>
											 </div>
										</div>

                    <div slot="modal-footer" class="w-100">
                      <b-button @click="deleteItemAndCloseDeleteConfirmBox" class="btn button-primary float-right mr-2"> yes </b-button>
                      <b-button @click="closeDeleteConfirmBox" class="btn button-primary float-right mr-2"> no </b-button>
                    </div>
                  </b-modal>
                </div>

                <div>
                  <b-modal class="modal__v22_2" ref="selectCompetencyModal" :title="'Action Needed'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                    <div slot="modal-header" class="row header-section w-100">
                      <div class="col-8 hd">
                    		<div class="ic_container">

          							</div>
                        <div class="hd_txt">
                          <span>Action Needed</span>
                        </div>
            					</div>
                      <div class="col-4 btn_container pr-0">
                        <button class="btn_close" aria-label="close" @click="closeSelectCompetencyModal">
                           <span class="ic-close"></span>
                        </button>
                      </div>
                    </div>

                    <div class="row modal_msg_container">
											<div class="col-12 msg_sec">
												 <span>Please select a competency</span>
											 </div>
										</div>

                    <div slot="modal-footer" class="w-100">
                      <b-button @click="closeSelectCompetencyModal" class="btn button-primary float-right mr-2"> ok </b-button>
                    </div>
                  </b-modal>
                </div>

                <div>
                  <b-modal class="modal__v22_2" ref="saveingCompetencyModal" :title="'Action Needed'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                    <div slot="modal-header" class="row header-section w-100">
                      <div class="col-8 hd">
                        <div class="ic_container">

                        </div>
                        <div class="hd_txt">
                          <span>Action Needed</span>
                        </div>
                      </div>
                      <div class="col-4 btn_container pr-0">
                        <button class="btn_close" aria-label="close" @click="closeSaveingCompetencyModal">
                           <span class="ic-close"></span>
                        </button>
                      </div>
                    </div>

                    <div class="row modal_msg_container">
                      <div class="col-12 msg_sec">
                        <span>You can add to this Competency after saving.</span>
                      </div>
										</div>

                    <div slot="modal-footer" class="w-100">
                      <b-button @click="closeSaveingCompetencyModal" class="btn button-primary float-right mr-2"> ok </b-button>
                    </div>
                  </b-modal>
                </div>

              </div>

              <div class="col-6 curate-right-section datatable">
                <!--
                <button>Filter</button>
                <input type="text" class="input-search" placeholder="type in search term and/or click search" v-model.trim="terms">
                <button @click="searchWithTerms">Search</button>
                <button @click="addToTopic">Add Resource to Competency</button>
                -->

                <b-row class="search_result_container">
                  <b-col cols="12" class="px-0">

                    <div class="msg_no_result" v-if="results.length === 0">
                      No results found!
                    </div>

                    <b-list-group>
					  <div class="result_row table-content-header">
						  <div class="left-column float-left">
							  <div class="checkbox select-all">
								<span class="form-checkbox" aria-labe="select all">
								  <input type="checkbox" @click="selectAll" v-model="allSelected" aria-labelledby="selectedAll">
								</span>
							  </div>
							  <div class="out-of-total-item">
                  		        <div class="selected-rows" id="selectedAll">Selected {{ this.selectedResult.length }} out of {{this.total}}</div>
          		            </div>
						  </div>
						  <div class="right-container">
                  		    <div class="number-of-item">
								<div class="number-of-item">
	                  		        <b-dropdown id="ddown-buttons" :text="''+size" :options="sizeOptions">
	                                    <b-dropdown-item-button v-for="option in sizeOptions" @click="changeSize(option)" aria-label="size options">{{option}}</b-dropdown-item-button>
	                  		        </b-dropdown>
	                  		    </div>
                  		    </div>
                  		    <div class="pagination btn_container pagination_sty3">
                  		        <button type="button" class="btn btn_trans" @click="prevPage" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                  		        <span class="current-page" aria-label="current page">{{pageNumber}}</span>
                  		        <button type="button" class="btn btn_trans" @click="nextPage" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                  		    </div>
						  </div>
					  </div>

					  <div class="content-scroll-column">
						  <div class="flex-column align-items-start result_row" v-for="(result, index) in results" :key="result.uuid" v-bind:class="{ added: result.isAdded }">
							<div class="facet_list">
							  <div class="checkbox">
								<span class="form-checkbox" v-if="!result.isAdded">
								  <input type="checkbox" :id="'ch_' + index" :value="result" :state = "updateSelectAll" v-model="selectedResult" :aria-labelledby="'selectEntity' + index">
								  <i class="form-icon"></i>
								</span>
								<span class="form-checkbox" v-if="result.isAdded">
								  <input type="checkbox" :id="'ch_' + index" disabled aria-label="disable field">
								  <i class="form-icon"></i>
								</span>
							  </div>
							</div>

							<div class="result_block">
							  <div class="d-flex w-100">
								<div class="title_icon">
                  <div v-if="result.resourceType === 'deliverycontext'" class="icon-course"></div>
                  <div v-if="result.resourceType === 'learningtopic'" class="module_icon ic24-microCompetency" title="Micro Competency"></div>
								  <div v-if="result.fileType === 'assessment'" class="icon-assessment float-left"></div>
								  <div v-if="result.fileType === 'video'" class="icon-video float-left"></div>
								  <div v-if="result.fileType === 'pdf'" class="icon-file-pdf float-left"></div>
								  <span v-if="result.fileType === 'csv'" class="icon icon-csvFile float-left"></span>
								  <span v-if="result.fileType === 'txt'" class="icon icon-file-text float-left"></span>
								  <span v-if="result.fileType === 'mp4' || result.fileType === 'mp3'" class="icon icon-video float-left"></span>
                  <span v-if="result.fileType === 'zip'" class="icon icon-file-zip float-left"></span>
                  <span v-if="result.fileType === 'scorm'" class="icon icon-scorm float-left" style="color: #b8652a;"></span>
								  <div v-if="result.fileType === 'doc' || result.fileType === 'docx'" class="icon-file-word float-left"></div>
								  <div v-if="result.fileType === 'xlsx' || result.fileType === 'xls'" class="icon-file-excel float-left"></div>
								  <div v-if="result.fileType === 'pptx' || result.fileType === 'ppt'" class="icon-pagePPT float-left"></div>
								  <div v-if="result.fileType === 'html'" class="icon-pageURL float-left"></div>
								  <div v-if="result.fileType === 'externalurl'" class="icon-pageURL float-left"></div>
								  <div v-if="result.fileType === 'jpg' || result.fileType === 'jpeg' || result.fileType === 'png' || result.fileType === 'gif'" class="icon-image float-left"></div>
								  <div v-if="result.fileType === 'other'"  class="icon-asset float-left"></div>
								</div>
								<label :for="'ch_' + index" :id="'selectEntity' + index" class="title">{{result.title}}</label>
                <div v-if="result.isAdded">
									<b-btn class="link_detail icon-link2" :id="'competencyMapping_' + index" aria-label="competency mapping"></b-btn>
									 <div class="curate-popup">
										<b-popover ref="curatePopup" :target="'competencyMapping_' + index" triggers="click" placement="top"  class="mapping-popup">
											<div class="content-section">
												<span class="icon-ic_ToC float-left" style="font-size: 45px;"></span>
												<span class="competency-title" style="font-size: 17px; margin-top: 4px;"><span v-if="result.mc">({{result.mc}})</span></span>
											</div>
											<div slot="title" class="curate-header-section">
												<h3 class="title">Competency Mapping</h3>
												<b-btn class="btn close-button" @click="closeMappingPopup('competencyMapping_' + index)" aria-label="close"> X </b-btn>
											</div>

										</b-popover>
									</div>
								</div>
								<small style="display: none;">{{result.lastUpdatedTime}}</small>
							  </div>

							  <div class="result_block_row" style="display: none;">
								<div class="icon_container">
								  <span class="icon-paragraph-left"></span>
								</div>
								<div v-if="result.description" class="description">
								  {{result.description}}
								</div>
								<div v-else class="no-description">
								  No description added for this content
								</div>
							  </div>

							  <div class="result_block_row auto_extracted_info" style="display: none;">
								<div class="icon_container">
								  <span class="icon-extract"></span>
								</div>
								<div class="details">
								  <div class="tags">
									<div class="no_tags"></div>
								  </div>
								  <span class="icon-pencil2" v-on:click="showTagsPopup()"></span>
								</div>
							  </div>

							  <div class="result_block_row tags_row" style="display: none;">
								<div class="icon_container">
								  <span class="ic-tag"></span>
								</div>
								<div class="details">
								  <div class="tags_container" v-if="result.appliedTagMap && result.appliedTagMap.general">
									<div class="tag" v-for="tag in result.appliedTagMap.general">
									  <span class="tag_name instructional_tag">{{tag.name}}</span>
									  <span class="icon_del">X</span>
									</div>
								  </div>
								  <span class="icon-pencil2" v-on:click="showTagsPopup()"></span>
								  </div>
							  </div>
							</div>

							<div class="thumbnail" style="display: none;">
							  <div v-if="result.resourceType === 'learningcontent'">
								<div class="thumbnail_default icon-asset"></div>
							  </div>
							  <div v-if="result.resourceType === 'deliverycontext'">
								<div class="thumbnail_default icon-course"></div>
							  </div>
							</div>

						  </div>
						</div>
                      </b-list-group>
                    </b-col>
                </b-row>
              </div>

            </div>

            </div>
          </div>

        </div>
        <b-modal id="filtering" class="filter-popup" :busy="true" hide-footer no-close-on-backdrop no-close-on-esc>
		 <div slot="modal-header" class="header-section">
			<span class="icon-filter float-left"></span>
			<div class="popup-heading">Narrow Your Results</div>
			<button class="btn_close" aria-label="close" @click="closeFilterPopup">
                <span class="ic-close"></span>
            </button>
		  </div>
          <div cols="3" class="facets">
              <div class="facet_block_container">
                  <div class="facet_block">
                      <div class="head">
                          <div class="checkbox">
                            <!--
                              <b-form-checkbox><label></label></b-form-checkbox>
                            -->
                          </div>
                          <div class="head_txt">Folders</div>
                      </div>

                      <div class="facet_row_container">
                          <b-form-group aria-label="select folders list">
                              <b-form-checkbox-group plain stacked v-model="foldersSelected" aria-label="selected folders" :options="folders" />
                          </b-form-group>
                      </div>
                  </div>

                  <div class="facet_block">
                    <div class="head">
                      <div class="checkbox">
                        <!--
                        <b-form-checkbox><label></label></b-form-checkbox>
                      -->
                      </div>
                      <div class="head_txt">Entity Type</div>
                      <div class="icon_container">
                        <b-btn v-b-toggle.entityType>
                          <span class="collapsed icon-collapse"></span>
                          <span class="expand icon-expand"></span>
                        </b-btn>
                      </div>
                    </div>
                    <b-collapse visible id="entityType">
                      <div class="facet_row_container">
                        <b-form-group aria-label="entity type list">
                          <b-form-checkbox-group plain stacked v-model="indexesSelected" aria-label="select entity type" :options="indexes" disabled/>
                        </b-form-group>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="facet_block">
                    <div class="head">
                      <div class="checkbox">
                      <!--
                        <b-form-checkbox><label></label></b-form-checkbox>
                      -->
                      </div>
                      <div class="head_txt">Asset Type</div>
                      <div class="icon_container">
                        <b-btn v-b-toggle.assetType>
                          <span class="collapsed icon-collapse"></span>
                          <span class="expand icon-expand"></span>
                        </b-btn>
                      </div>
                    </div>
                    <b-collapse visible id="assetType">
                      <div class="facet_row_container">
                        <b-form-group aria-label="select asset type">
                          <b-form-checkbox-group plain stacked v-model="assetTypeSelected" aria-label="selected asset" :options="assetType" />
                        </b-form-group>
                      </div>
                    </b-collapse>
                  </div>
              </div><!-- facet_block_container -->
          </div><!-- facets -->

        </b-modal>
    </div>
</template>

<script>
/* eslint no-labels: ["error", { "allowLoop": true }] */
import '../../../assets/module/sass/course/courseCurate.scss'
import Vue from 'vue'
import draggable from 'vuedraggable'
import { mapState, mapActions } from 'vuex'
import CourseHeader from './CourseHeader'
import CourseNav from './CourseNav'
import Autocomplete from 'vuejs-auto-complete'
import Datepicker from 'vuejs-datepicker'
import { getSimpleLibraryFilter } from '../../search/searchUtils.js'
import Vuelidate from 'vuelidate'
import {required, url, numeric, minValue} from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

var DisableDate = function () {
  const date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}
var EntityData = function (id, title, type, contentFileType, fileType) {
  this.id = id
  this.uuid = undefined
  this.uri = undefined
  this.title = title
  this.type = type
  this.action = undefined
  this.thumbnail = undefined
  this.isDataRendered = false
  this.isStudentEditable = false
  this.children = []
  this.contentFileType = contentFileType
  this.fileType = fileType
  this.html = undefined
  this.originUuid = undefined
}

export default {
  name: 'course-curation',
  props: ['uuid'],
  components: {
    draggable,
    CourseHeader,
    CourseNav,
    Autocomplete,
    Datepicker
  },
  data: () => {
    return {
      courseTitle: '',
      newCompetencyTitle : '',
      newCompetencyDescription : '',
      newCompetencyType : '',
      itemTitle: '',
      itemUri: '',
      itemDescription: '',
      assessmentMaxAttempt: 1,
      topicUuid: '',
      subTopicUuid: '',
      itemToEdit: '',
      itemToDelete: '',
      savingButtonMessage:'Go',
      allMCs:[{uuid:'11111', title:'MCzz'}, {uuid:'11112', title:'MCxx'}],
      allCs:[{uuid:'21111', title:'Czz'}, {uuid:'21112', title:'Cxx'}],
      unlockDate:undefined,
        disabledDates: {
          to: new DisableDate()
        },
        months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      selectionType: 0,
      unlockReliantOn: undefined,
      unlockReliantOnTitle: undefined,
      unlockReliantOnMCTitle: undefined,
      contentType:'',
      itemDeleteMessage: '',
      items: [],
      userLibraryList: [],
      entityId: 0,
      entityType: {
        TOPIC: 'LearningTopic',
        ASSET: 'LearningContent'
      },
      showNote: false,
      isDragging: false,
      delayedDragging: false,
      folders: [],
      foldersSelected: [],
      allFolders: [],
      privateLibraryList: [],
      publicLibraryList: [],
      selectionsForAction: [],
      parentSharedLib:[],

      userId: '',
      userRole: '',
      libraryList: '',
      indexes: [
        {
          text: 'MicroCompetency [0]',
          value: 'LearningTopic',
          checked: true
        }
      ],
      indexesSelected: ['LearningTopic', 'LearningContent'],
      allIndexes: ['learningtopic', 'learningcontent'],
      assetType: [],
      assetTypeSelected: [],
      indexList: '',
      facets: {},
      filter: {},
      query: {},
      sort: [{lastUpdatedTime: {order: 'desc'}}],
      source: ['title', 'uuid', 'name', 'description', 'type', 'creationTime', 'lastUpdatedTime', 'thumbnail', 'thumbnailURI', 'thumbnailURIList', 'uri', '_score', 'appliedTagMap', 'aggregatedAppliedTags', 'fileType', 'originUuid', 'localPractice', 'maxAttempt', 'whiteListed', 'blackListed'],
      sizeOptions: [ 10, 50, 100 ],
      terms: undefined,
      selectedComptency: undefined,
      selectedResult: [],
      allSelected: false,
      alreadyAddedResult: '',
      selectMCFromList: '',
      isFirstTimeLoad: true
    }
  },

  validations: {
    contentUri: {
      required,
      url
    },
    assessmentMaxAttempt: {
      required,
      numeric,
      minVal: minValue(1)
    }
  },

  mounted () {
    this.loadCourseDetail(this.uuid).then((res) => {
      this.courseTitle = this.course.title
    })
    this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true}).then(res => {
      this.renderTopicPlan(this.topics, this.items)
      this.userId = localStorage.getItem('userid')
      this.userRole = localStorage.getItem('userrole')

      this.loadAllLibrariesForUser(this.userId).then(learningSpaces => {
        for (var i = 0; i < learningSpaces.length; i++) {
          var learningSpace = learningSpaces[i]
          const category = learningSpace.category
          if (category === 'LearningSpace' || category === 'Institute_Public' || category === 'User_Private') {
            this.folders.push({value: learningSpace.uuid, text: learningSpace.displayName + ' [0]', checked: true})
            this.allFolders.push(learningSpace.uuid)
            this.foldersSelected.push(learningSpace.uuid)
            if (category !== 'Institute' && category !== 'User_Private') {
              this.publicLibraryList.push(learningSpace.uuid)
            }
            if (category === 'User_Private') {
              this.privateLibraryList.push(learningSpace.uuid)
            }
          // exclude shared
            if(this.institution.parentSharedLibs && this.institution.parentSharedLibs.length>0){
              if(!this.institution.parentSharedLibs.includes(learningSpace.uuid)){
                this.userLibraryList.push(learningSpace.uuid)
              }
            }
          }
        }

        if(this.institution.parentSharedLibs && this.institution.parentSharedLibs.length>0){
            $.each(this.institution.parentSharedLibs, (j, folder) => {
                this.parentSharedLib.push(folder)
              })
        }

        this.terms = ''
        this.constructQuery()
      })
    })
  },

  updated () {
    if (this.isFirstTimeLoad) {
      topicLoop: for (var i = 0; i < this.items.length; i++) {
        const topic = this.items[i]
        this.topicUuid = topic.uuid
        subTopicLoop: for (var j = 0; j < topic.children.length; j++) {
          const subtopic = topic.children[j]
          this.subTopicUuid = subtopic.uuid
          break topicLoop
        }
      }
      if ($('#ic_' + this.topicUuid).hasClass('collapsed')) {
        this.isFirstTimeLoad = false
        $('#ic_' + this.topicUuid).trigger('click')
        $('#rw_' + this.topicUuid).toggleClass('row_expanded row_collapsed')
      }
      if ($('#ic_' + this.subTopicUuid).hasClass('collapsed')) {
        if (!$('#ic_' + this.subTopicUuid).hasClass('collapsed_intentionally')) {
          $('#ic_' + this.subTopicUuid).trigger('click')
          $('#rw_' + this.subTopicUuid).toggleClass('row_expanded row_collapsed')
          $('#ic_' + this.subTopicUuid).addClass('collapsed_intentionally')
        }
      }
    }
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadCourseTopics',
      'loadSearchResults',
      'loadAllLibrariesForUser',
      'constructSearchQuery',
      'updateResultIsAdded',
      'updateResultIsAddedByUUID',
      'updateResultMCInfo',
      'updateResultMCInfoByUUID',
      'updateFrom',
      'loadAddPrePostCompetency',
      'updatePageNumber',
      'updateSize',
      'addReleaseLogicForMC',
      'loadMicroCompetencyDetail',
      'loadCompetencyTopics',
      'loadMicroCompetencyTopics',
      'createCopy',
      'saveCourseDetail'
    ]),

    updateFolder () {
      this.constructQuery()
    },

    updateFacet () {
      this.constructQuery()
    },

    ensureLockInfo (subtopic) {
        const hasUnlockRule =
          subtopic.unlockReliantOnType &&
          subtopic.unlockReliantOnTitle &&
          subtopic.unlockReliantOnTitle.length

        const text = hasUnlockRule
          ? subtopic.unlockReliantOnTitle[0]
          : null

        this.$set(subtopic, 'isLocked', !!hasUnlockRule)
        this.$set(subtopic, 'unlockText', text)
        this.$set(subtopic, 'lockLoaded', true)
    },

    addToTopic () {
      if (this.selectedComptency) {
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].uuid === this.selectedComptency) {
            for (var m = 0; m < this.selectedResult.length; m++) {
              var entityToBeAdded = this.createNewEntity(this.selectedResult[m], 'COPY')
              this.items[i].children.push(entityToBeAdded)
              this.updateResultIsAddedByUUID(this.selectedResult[m].uuid)
              var mcInfo2 = {
                uuid: this.selectedResult[m].uuid,
                mc: this.items[i].title
              }
              this.updateResultMCInfoByUUID(mcInfo2)
            }
          }
          for (var j = 0; j < this.items[i].children.length; j++) {
            if (this.items[i].children[j].uuid === this.selectedComptency) {
              for (var k = 0; k < this.selectedResult.length; k++) {
                var entity = this.createNewEntity(this.selectedResult[k], 'COPY')
                this.items[i].children[j].children.push(entity)
                this.updateResultIsAddedByUUID(this.selectedResult[k].uuid)
                var mcInfo = {
                  uuid: this.selectedResult[k].uuid,
                  mc: this.items[i].children[j].title
                }
                this.updateResultMCInfoByUUID(mcInfo)
              }
            }
          }
        }
        this.selectedResult = []
        $('.add-to-topic').hide()
      }
    },

    closeMappingPopup (competencyMappingPopup) {
      this.$root.$emit('bv::hide::popover', competencyMappingPopup)
    },

    closeFilterPopup () {
      this.$root.$emit('bv::hide::modal', 'filtering')
    },

    updateSelectedResults () {
      for (var i = 0; i < this.topics.length; i++) { // topic
        for (var j = 0; j < this.topics[i].subtopics.length; j++) {
          if (this.topics[i].subtopics[j].subtopics) {
            for (var k = 0; k < this.topics[i].subtopics[j].subtopics.length; k++) {
              for (var m = 0; m < this.results.length; m++) {
                if (this.topics[i].subtopics[j].action === undefined || this.topics[i].subtopics[j].action !== 'DELETE') {
                    if ((this.results[m].uuid === this.topics[i].subtopics[j].originUuid) || (this.results[m].uuid === this.topics[i].subtopics[j].rootOriginUuid)) {
                    this.updateResultIsAdded({index: m, status: true})
                    var mcInfo = {
                      index: m,
                      mc: this.topics[i].title
                    }
                    this.updateResultMCInfo(mcInfo)
                  }

                }
                if (this.topics[i].subtopics[j].subtopics[k].action === undefined || this.topics[i].subtopics[j].subtopics[k].action !== 'DELETE') {
                  if ((this.results[m].uuid === this.topics[i].subtopics[j].subtopics[k].originUuid) || (this.results[m].uuid === this.topics[i].subtopics[j].subtopics[k].rootOriginUuid)) {
                    this.updateResultIsAdded({index: m, status: true})
                    var mcInfo = {
                      index: m,
                      mc: this.topics[i].subtopics[j].title
                    }
                    this.updateResultMCInfo(mcInfo)
                  }
                }
              }
            }
          }
        }
      }
    },

    selectAll () {
      if (this.allSelected === false) {
        var selectedResult = []
        this.results.forEach(function (result) {
          selectedResult.push(result)
        })
        this.selectedResult = selectedResult
      } else {
        this.selectedResult = []
      }
    },

    prevPage () {
      if (this.pageNumber >= 1 && (this.from - this.size) >= 0) {
        this.updatePageNumber(this.pageNumber - 1)
        this.updateFrom(this.from - this.size)
        this.constructQuery(false)
      }
    },

    nextPage () {
      if ((this.from + this.size) <= this.total) {
        this.updatePageNumber(this.pageNumber + 1)
        this.updateFrom(this.from + this.size)
        this.constructQuery(false)
      }
    },

    changeSize (option) {
      this.updateSize(option)
      this.updateFrom(0)
      this.updatePageNumber(1)
      this.constructQuery()
    },

    removeSelected (entity) {
      for (var m = 0; m < this.results.length; m++) {
        if ((this.results[m].uuid === entity.originUuid) || (this.results[m].uuid === entity.rootOriginUuid)) {
          this.updateResultIsAdded({index: m, status: false})
          var mcInfo = {
            index: m,
            mc: ''
          }
          this.updateResultMCInfo(mcInfo)
        }
      }
    },

    addCompetency (uuid, children) {
      if(!uuid){
        this.$refs.saveingCompetencyModal.show()
        return
      }
      this.selectedComptency = uuid
      if (this.selectedResult.length > 0) {
        $('.add-to-topic').show()
      } else {
        $('.add-to-topic').hide()
      }
    },

    addResource (result) {
      this.selectedResult = result
    },

    activateLinkResourseButton () {
      if (this.selectedComptency !== undefined) {
        for (var m = 0; m < this.results.length; m++) {
          if ($('#ch_' + m).is(':checked') === true) {
            $('.add-to-topic').show()
            break
          } else {
            $('.add-to-topic').hide()
          }
        }
      }
    },

    searchWithTerms () {
      this.constructQuery()
    },
    constructQuery () {
      // construct the libraryList
      this.libraryList = []
      this.indexList = []
      for (var i = 0; i < this.allFolders.length; i++) {
        if (this.libraryList.length === 0) {
          this.libraryList = this.allFolders[i]
        } else {
          this.libraryList = this.libraryList + ',' + this.allFolders[i]
        }
      }
      // construct the indexList
      for (i = 0; i < this.allIndexes.length; i++) {
        if (this.indexList.length === 0) {
          this.indexList = this.allIndexes[i]
        } else {
          this.indexList = this.indexList + ',' + this.allIndexes[i]
        }
      }

      // construct facets
      this.facets = {
        'library': {
          'aggs': {
            'termObj': {
              'terms': {
                'field': 'owningLibraryId.keyword',
                'size': 100
              }
            }
          },
          'filter': this.getFacetFilter('owningLibraryId')
        },
        'type': {
          'aggs': {
            'termObj': {
              'terms': {
                'field': '_type'
              }
            }
          },
          'filter': this.getFacetFilter('_type')
        },
        'assetType': {
          'aggs': {
            'termObj': {
              'terms': {
                'field': 'fileType.keyword',
                'size': 100
              }
            }
          },
          'filter': this.getFacetFilter('fileType')
        }
      }

      // construct filter
      this.filter = this.generateFilter()

      this.constructSearchQuery({ terms: this.terms, sort: this.sort, source: this.source, from: this.from, size: this.size, indexList: this.indexList, libraryList: this.libraryList, privateLibraryList: this.privateLibraryList, publicLibraryList: this.publicLibraryList, userId: this.userId, foldersSelected: this.foldersSelected, aggs: this.facets, filter: this.filter }).then((res) => {
        this.updateSelectedResults()
      })
    },

    generateFilter () {
      // origin UUID
      var filterObj = {
        'bool': this.originUuidCheck()
      }

      // Folders
      if (this.foldersSelected.length > 0) {
        let orQuery = {
          'bool': {
            'should': [
              getSimpleLibraryFilter(this.foldersSelected)
            ]
          }
        }
        filterObj.bool.must.push(orQuery)
      }

      // Content Type
      if (this.indexesSelected.length > 0) {
        var terms = {
          'terms': {
            '_type': this.indexesSelected
          }
        }
        filterObj.bool.must.push(terms)
      }
      // Assest Type
      if (this.assetTypeSelected.length > 0) {
        var assetTerms = {
          'terms': {
            'fileType': this.assetTypeSelected
          }
        }
        filterObj.bool.must.push(assetTerms)
      }
      return filterObj
    },

    getFacetFilter (facetType) {
      var facetFilterObj = {
        'bool': this.originUuidCheck()
      }

      if (facetType === 'owningLibraryId') {
        facetFilterObj.bool.must.push(getSimpleLibraryFilter(this.allFolders))
      } else if (facetType !== 'enrolledCourses') {
        if (this.foldersSelected.length > 0) {
          let orQuery = {
            'bool': {
              'should': [
                getSimpleLibraryFilter(this.foldersSelected)
              ]
            }
          }
          facetFilterObj.bool.must.push(orQuery)
        }
        if (facetType === 'fileType') {
          var terms = {
            'terms': {
              '_type': this.indexesSelected
            }
          }
          facetFilterObj.bool.must.push(terms)
        }
      }

      return facetFilterObj
    },

    originUuidCheck () {
      var originUuidCheck = {
        'must': [],
        'must_not': [{
          'exists': {
            'field': 'originUuid'
          }
        },
        {
          "bool": {
            "must": [
              {
                "term": {
                  "_type": "LearningContent"
                }
              },
              {
                "bool": {
                  "should": [
                    {
                      "terms": {
                        "owningLibraryId": this.parentSharedLib
                      }
                    }
                  ]
                }
              }
            ]
          }
        },
        {
          "bool": {
            "must": [
              {
                "term": {
                  "_type": "LearningTopic"
                }
              },
              {
                "bool": {
                  "should": [
                    {
                      "bool": {
                        "must_not": {
                          "exists": {
                            "field": "published"
                          }
                        }
                      }
                    },
                    {
                      "term": {
                        "published": false
                      }
                    }
                  ]
                }
              }
            ]
          }
        }
        ]
      }
      return originUuidCheck
    },

    onMove (ev) {
      if (ev.draggedContext.element.action === undefined || ev.draggedContext.element.action !== 'COPY') {
        ev.draggedContext.element.action = 'MOVE'
      }
    },

    createNewEntity (item, action) {
      if (item) {
        var type = this.entityType.TOPIC
        if (item.fileType ==='assessment' || item.resourceType === 'learningcontent' || item.objectType === 'LearningContent' || item.resourceType === 'lmscontent' || item.objectType === 'lmscontent' || item.type === 'LearningContent') {
          type = this.entityType.ASSET
        }
        var id = this.entityId++
        var entity = new EntityData(id, item.title, type, item.contentFileType, item.fileType)
        entity.sharedCopy = item.sharedCopy
        entity.unlockReliantOnType =item.unlockReliantOnType
        entity.unlockReliantOnTitle =item.unlockReliantOnTitle

        if (item.uuid) {
          entity.uuid = item.uuid
        }
        if (item.externalId) {
          entity.externalId = item.externalId
        }
        if (item.importedExportedSynced) {
          entity.importedExportedSynced = item.importedExportedSynced
        }
        if (item.uri) {
          entity.uri = item.uri
        }
        if (item.thumbnail) {
          entity.thumbnail = item.thumbnail
        }
        if (item.embedlyHtml) {
          entity.html = item.embedlyHtml
        }
        if (item.description) {
          entity.description = item.description
        }
        if (item.originUuid) {
          entity.originUuid = item.originUuid
        }
        if (item.rootOriginUuid) {
          entity.rootOriginUuid = item.rootOriginUuid
        }
        if (item.ancestor) {
          entity.ancestor = item.ancestor
        }
        if (item.owningLibraryId) {
          entity.owningLibraryId = item.owningLibraryId
        }
        if (item.studentEditable) {
          entity.isStudentEditable = item.studentEditable
        }
        entity.customType = item.type
        if (item.fileSize) {
          entity.fileSize = item.fileSize
        }
        if (item.appliedTagMap) {
          var appliedTagMap = item.appliedTagMap
          entity.appliedTagMap = appliedTagMap
        }
        if (item.localPractice) {
          entity.localPractice = item.localPractice
        }
        if (item.maxAttempt) {
          entity.maxAttempt = item.maxAttempt
        }
        if (item.creationTime) {
          entity.creationTime = item.creationTime
        }
        if (item.whiteListed) {
          entity.whiteListed = item.whiteListed
        }
        if (item.blackListed) {
          entity.blackListed = item.blackListed
        }
        if (action) {
          entity.action = action
        }
        return entity
      }
    },

    renderTopicPlan (plan, data, action) {
      if (plan) {
        $.each(plan, (index, item) => {
          var newEntity = this.createNewEntity(item)
          if (action) {
            newEntity.action = action
          }
          if (newEntity.type === this.entityType.TOPIC) {
            newEntity.isDataRendered = true
          }
          data.push(newEntity)
          if ((item.objectType === this.entityType.TOPIC) && item.plan) {
            this.renderTopicPlan(JSON.parse(item.plan), newEntity.children, action)
          }
        })
      }
    },

    switchClass (rowId) {
      var elem = $('#rw_' + rowId)
      if (elem.hasClass('ic-expand_r')) {
        elem.removeClass('ic-expand_r')
        elem.addClass('ic-collapse_r')
      } else {
        elem.removeClass('ic-collapse_r')
        elem.addClass('ic-expand_r')
      }
    },

    addExpandClass (rowId) {
      $('#rw_' + rowId).toggleClass('row_expanded row_collapsed')
    },

    openItemEditBox (type, item) {
      this.itemToEdit = item
      this.itemTitle = item.title
      this.itemDescription = item.description
      if (type === 'competency') {
        this.$refs.competencyEditModal.show()
      } else if (type === 'microCompetency') {
          this.loadMicroCompetencyDetail(this.itemToEdit.originUuid).then((res) => {
          if(!this.userLibraryList.includes(res.owningLibraryId)){
            this.itemToEdit.sharedCopy = true;
          }
          this.savingButtonMessage = 'go'
          this.$refs.microCompetencyEditStartModal.show()
        })
      } else if (type === 'content') {
        if (item.customType === 'ASSESSMENT') {
          this.assessmentMaxAttempt = item.maxAttempt
          this.$refs.assessmentEditModal.show()
        } else {
          this.itemUri = item.uri
          this.itemType = item.customType
          this.$refs.resourceEditModal.show()
        }
      }
    },
    openMCEditBox(){
      this.$refs.microCompetencyEditModal.show()
    },
    async openMCReleaseBox(){
      this.allCs = []
      await this.loadCompetencyTopics({courseId:this.course.uuid, mcId:this.itemToEdit.uuid}).then((res) => {
          $.each(res, (i, tempC) => {
            let cinfo = {uuid:tempC.uuid, title:tempC.title}
              this.allCs.push(cinfo)
          })

      })
      this.allMCs = []
      await this.loadMicroCompetencyTopics({courseId:this.course.uuid, mcId:this.itemToEdit.uuid}).then((res) => {
          $.each(res, (i, tempMC) => {
            let mcinfo = {uuid:tempMC.uuid, title:tempMC.title}
              this.allMCs.push(mcinfo)
          })

      })

      this.loadMicroCompetencyDetail(this.itemToEdit.uuid).then((res) => {
          this.selectionType=res.unlockReliantOnType?res.unlockReliantOnType:this.selectionType
          this.unlockReliantOn = res.unlockReliantOn?res.unlockReliantOn[0]:undefined
          this.unlockReliantOnTitle = undefined
          this.unlockReliantOnMCTitle = undefined
          if(res.unlockReliantOnType==2){
              this.unlockDate = res.unlockReliantOnTitle[0]
          }else if(res.unlockReliantOnType==4){
              this.unlockReliantOnTitle = res.unlockReliantOnTitle?res.unlockReliantOnTitle[0]:undefined
          }else if(res.unlockReliantOnType==5){
              this.unlockReliantOnMCTitle = res.unlockReliantOnTitle?res.unlockReliantOnTitle[0]:undefined
          }
          this.$refs.microCompetencyReleaseModal.show()
      })
    },
    closeMCReleaseBox(){
      this.$refs.microCompetencyReleaseModal.hide()
    },
    getDynamicSelectFormattedDisplay (selectedObj) {
        return selectedObj.title || selectedObj
    },
    getDynamicSelectPlaceholder (type) {
      if(type=='competency'){
        return this.unlockReliantOnTitle || 'start typing and/or click'
      }
      if(type=='mc'){
        return this.unlockReliantOnMCTitle || 'start typing and/or click'
      }

    },
    resetList (){
        this.unlockReliantOn =  undefined
        this.unlockReliantOnTitle = undefined
        this.unlockReliantOnMCTitle = undefined

        if(this.selectionType==1){
          this.unlockReliantOn =  "MANUAL"
        }
        if(this.selectionType==2){
          this.unlockReliantOn =  undefined
          if(this.unlockDate){
            this.unlockReliantOn = this.changeDateToString(this.unlockDate)
          }
        }
    },
    dynamicSelectAfterSelected (item) {
          this.unlockReliantOn =  item.selectedObject.uuid
          if(this.selectionType==4){
            this.unlockReliantOnTitle = item.selectedObject.title
          }
          if(this.selectionType==5){
            this.unlockReliantOnMCTitle = item.selectedObject.title
          }
    },
    changeDateToString (selected) {
      if (selected) {
        const date = new Date(selected)
        let mm = String(this.months[date.getMonth()])
        let dd = date.getDate()
        if (dd < 10) {
          dd = '0' + dd
        }
        let yyyy = date.getFullYear()
        let formatted = mm +'-'+ dd +'-'+ yyyy
        return formatted
      }
      return undefined
    },

    changeDateFormat (selected) {
      if (selected && selected.length > 0) {
        const mm = selected.slice(0, 2)
        const dd = selected.slice(2, 4)
        const yyyy = selected.slice(4)
        return mm + '/' + dd + '/' + yyyy
      }
      return selected
    },
    updateReleaseLogic (){
      if(this.selectionType==2 ){
        if(this.unlockDate){
          this.unlockReliantOn = this.changeDateToString(this.unlockDate)
          $('#unlockDateFeedback').hide()
        }else{
          $('#unlockDateFeedback').show()
          return
        }
      }
      this.addReleaseLogicForMC({courseId:this.course.uuid, mcId:this.itemToEdit.uuid, type:this.selectionType, depndesOn:this.unlockReliantOn}).then((res) => {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Micro Competency release logic successfully added.'
          })
          this.itemToEdit.unlockReliantOnType =res.unlockReliantOnType
          this.itemToEdit.unlockReliantOnTitle =res.unlockReliantOnTitle
          this.ensureLockInfo(this.itemToEdit)
        this.$refs.microCompetencyReleaseModal.hide()
      })
    },
    closeMCStartEditBox(){
      this.$refs.microCompetencyEditStartModal.hide()
      this.itemUri = ''
      this.itemType = ''
      this.itemTitle = ''
      this.itemDescription = ''
    },
    closeItemEditBox (type) {
      if (type === 'competency') {
        this.$refs.competencyEditModal.hide()
      } else if (type === 'microCompetency') {
        this.$refs.microCompetencyEditModal.hide()
      } if (type === 'assessment') {
        this.$refs.assessmentEditModal.hide()
      } else if (type === 'resource') {
        this.$refs.resourceEditModal.hide()
      }
      this.itemUri = ''
      this.itemType = ''
      this.itemTitle = ''
      this.itemDescription = ''
    },
    closeNewCompetencyBox (){
      this.newCompetencyType = ''
      this.newCompetencyTitle = ''
      this.newCompetencyDescription = ''
      this.$refs.addCompetencyModal.hide()
    },
    closeSelectCompetencyModal (){
        this.$refs.selectCompetencyModal.hide()
    },
    closeSaveingCompetencyModal(){
      this.$refs.saveingCompetencyModal.hide()
    },
    openNewCompetencyBox (type){
      if (!this.selectedComptency) {
          this.$refs.selectCompetencyModal.show()
          return
      }
      this.newCompetencyType = type
      this.newCompetencyTitle = ''
      this.newCompetencyDescription = ''
      this.$refs.addCompetencyModal.show()
    },


    createNewCompetency (){
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].uuid === this.selectedComptency) {
              var id = this.entityId++
              var entityToBeAdded = {id:id, title:this.newCompetencyTitle, description: this.newCompetencyDescription, action:'CREATE', type:this.entityType.TOPIC, isDataRendered: true, isStudentEditable:false, children:[], ancestor: this.items[i].ancestor, owningLibraryId:this.items[i].owningLibraryId}
              if(this.newCompetencyType==='Begin'){
                this.items.splice(i,0,entityToBeAdded)
              }else{
                this.items.splice(i+1,0,entityToBeAdded)
              }
              break;
          }
        }
        this.$refs.addCompetencyModal.hide()
    },
    updateAndCloseItemEditBox (type) {
      if (this.itemTitleState) {
        this.itemToEdit.title = this.itemTitle
        this.itemToEdit.description = this.itemDescription
        if (type === 'resource') {
          if (!this.$v.contentUri.$error) {
            if (this.contentType === 'REMOTE') {
              this.itemToEdit.uri = this.itemUri
            }
          }
        } else if (type === 'assessment') {
          if (!this.$v.assessmentMaxAttempt.$error) {
            this.itemToEdit.maxAttempt = this.assessmentMaxAttempt
          }
        }
        this.closeItemEditBox(type)
      }
    },
    editMaster(){
    return this.$router.push({ name: 'microCompetencyEdit', params: { uuid: this.itemToEdit.originUuid, opstate: 2} })
    },
    copyMaster (mc){
        this.savingButtonMessage = 'Saving please wait...'
        this.createCopy(mc.uuid).then(newMc => {
          if(newMc.uuid){
            // delete the old copy, add new and save
            this.addNewDeleteOld(newMc,mc)
            // save course
            this.course.plan = this.generatePlan(this.items)
            this.saveCourseDetail(this.course).then((savedCourse) => {
              this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: 'Successfully created and added copy of'+mc.title
              })
              this.savingButtonMessage = 'Go'
              return this.$router.push({ name: 'microCompetencyEdit', params: { uuid: newMc.uuid, opstate: 2} })
            })
          }else{
            this.showMessage('Error created copy of '+this.model.title)
          }
        })
    },
    generatePlan (plan) {
      $.each(plan, (i, item) => {
        delete item.id
        if (item.type === 'LearningTopic') {
          if (item.children.length > 0) {
            this.generatePlan(item.children)
          }
        } else {
          delete item.children
          delete item.isDataRendered
          delete item.isStudentEditable
        }
      })
      return JSON.stringify(plan)
    },
    showMessage (message, mType) {
      this.$notify({
        group: 'notify',
        type: mType,
        title: '',
        text: message
      })
    },
    showDeleteItemConfirmBox (type, item) {
      this.itemToDelete = item
      if (type === 'competency') {
        this.itemDeleteMessage = 'Are you sure you want to delete this competency?'
      } else if (type === 'microCompetency') {
        this.itemDeleteMessage = 'Are you sure you want to delete this micro competency?'
      } else if (type === 'content') {
        if (item.customType === 'ASSESSMENT') {
          this.itemDeleteMessage = 'Are you sure you want to delete this knowledge check?'
        } else {
          this.itemDeleteMessage = 'Are you sure you want to delete this resource?'
        }
      }
      this.$refs.deleteItemModal.show()
      $('#tc_' + this.itemToDelete.uuid).css('background', '#f9e4e1')
    },

    closeDeleteConfirmBox () {
      $('#tc_' + this.itemToDelete.uuid).css('background', 'none')
      this.$refs.deleteItemModal.hide()
    },

    deleteItemAndCloseDeleteConfirmBox () {
      this.itemToDelete.action = 'DELETE'
      if (this.itemToDelete.type === this.entityType.TOPIC) {
        this.deleteChild(this.itemToDelete.children)
      }
      this.closeDeleteConfirmBox()
      this.removeSelected(this.itemToDelete)
      this.constructQuery()
    },
    addNewDeleteOld (newCopy, oldCopy){
      for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].uuid === oldCopy.ancestor) {
              var entityToBeAdded = this.createNewEntity(newCopy, 'COPY')
            for (var j = 0; j < this.items[i].children.length; j++) {
              if (this.items[i].children[j].uuid === oldCopy.uuid) {
                this.items[i].children.splice(j+1, 0, entityToBeAdded);
                this.items[i].children[j].action = 'DELETE'
                this.deleteChild(this.items[i].children[j].children)
                break
              }
            }
          break
          }
      }
    },

    deleteChild (data) {
      $.each(data, (i, item) => {
        item.action = 'DELETE'
        if (item.type === this.entityType.TOPIC) {
          this.deleteChild(item.children)
        }
      })
    },

    afterSave (data) {
      this.items = []
      this.renderTopicPlan(data, this.items)
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'topics': state => state.course.topics,
      'results': state => state.search.results,
      'total': state => state.search.total,
      'facetResults': state => state.search.aggregations,
      'from': state => state.search.from,
      'pageNumber': state => state.search.pageNumber,
      'size': state => state.search.size,
      'sort': state => state.search.sort,
      'institution': state => state.institution.institution
    }),

    itemTitleState () {
      return this.itemTitle.length > 0
    },
    newCompetencyTitleState () {
      return this.newCompetencyTitle.length > 0
    },

    updateSelectAll () {
      if (this.selectedComptency !== undefined) {
        if (this.selectedResult.length === this.results.length) {
          this.allSelected = true
          $('.add-to-topic').show()
        } else {
          this.allSelected = false
        }
        if ((this.selectedResult.length && this.results.length) === 0) {
          this.allSelected = false
          $('.add-to-topic').hide()
        }
        if (this.selectedResult.length > 0) {
          $('.add-to-topic').show()
        }
      }
    },

    dragOptions () {
      return {
        animation: 0,
        group: 'content',
        disabled: false,
        ghostClass: 'ghost'
      }
    }

  },

  watch: {
    isDragging (newValue) {
      if (newValue) {
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    },

    selectMCFromList (newValue) {
      console.log('New Select MC FROM list: ', this.selectMCFromList)
    },

    foldersSelected (newFoldersSelected) {
      this.updateFacet()
      this.constructQuery()
    },

    facetResults (newFacet) {
      // process library
      var libTerms = this.facetResults.library.termObj.buckets || []
      var lib = {}
      for (var i = 0; i < libTerms.length; i++) {
        lib = libTerms[i]
        for (var j = 0; j < this.folders.length; j++) {
          if (this.folders[j].value === lib.key) {
            this.folders[j].text = this.folders[j].text.substr(0, this.folders[j].text.indexOf('[')) + '[' + lib.doc_count + ']'
          }
        }
      }

      // process content type
      var typeTerms = this.facetResults.type.termObj.buckets || []
      var type = {}
      for (i = 0; i < typeTerms.length; i++) {
        type = typeTerms[i]
        for (j = 0; j < this.indexes.length; j++) {
          if (this.indexes[j].value === type.key) {
            this.indexes[j].text = this.indexes[j].text.substr(0, this.indexes[j].text.indexOf('[')) + '[' + type.doc_count + ']'
          }
        }
      }

      // process assets
      var assetTerms = this.facetResults.assetType.termObj.buckets || []
      this.assetType = []
      var asset = {}
      for (i = 0; i < assetTerms.length; i++) {
        let assetTerm = assetTerms[i]
        asset = {
          'text': assetTerm.key + ' [' + assetTerm.doc_count + ']',
          'value': assetTerm.key
        }
        this.assetType.push(asset)
      }
    },
    assetTypeSelected (newAssetTypeSelected) {
      this.constructQuery()
    },

    indexesSelected (newIndexesSelected) {
      this.constructQuery()
    }
  }
}
</script>

<style scoped>

.content-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    border: dashed;
    background: #ebebeb;
}
.inputTitle {
    width: 92%;
    height: 15px;
}

.title {
    font-size: 17px
}

.close-button {
	position: absolute;
	right: 18px;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	justify-content: center;
	font-size: 13px;
	padding: 0px;
	top: 13px;
}

.content-section {
	float: left;
    width: 100%;
    margin-top: 5px;
    margin-left: 6px;
    margin-bottom: 13px;
}

.collapsed > .collapsed,
:not(.collapsed) > .expand {
  display: none;
}

.table-content-header, .table-content-header:hover {
	border-bottom: solid 1px rgb(217, 217, 217) !important;
	background: rgb(249, 249, 249) !important;
}

.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
}
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseCurationMC.vue